// Pages that do NOT assume an authenticated session and handle their own
// auth-related errors -- login, logout, confirmation/password-reset flows,
// and product-key activation are all reachable while logged out, so a 401
// there doesn't mean "your session expired," and must not be redirected away
// from by generic "not authenticated" handling elsewhere in the app.
//
// NOTE: /users/onboarding is deliberately excluded from this list despite
// living under /users/* -- per src/pages/Users/Users.tsx, it's only ever
// shown to an already-authenticated user (redirected there once currentUser.id
// is set and onboarding isn't complete), so a session expiring there should
// be treated like any other authenticated page, not skipped.
//
// This regex is used in two places, and both matter for that to hold:
// initializers/axiosSessionExpiry.ts (decide whether a 401 means "expired"), and
// the redirect guards in pages/App/App.js and pages/Users/Users.tsx. Users.tsx
// needs its own copy of the guard because /users/* is a sibling route subtree
// from App, so App never renders for these paths -- without it, excluding
// onboarding here would clear the session without ever redirecting.
export const AUTH_PATHS_REGEX =
  /^\/(users\/(login|logout|confirmation|reset-password|forgot-password|resend-email|activate-product-key)(\/|$)|single_logout(\/|$))/;
